import { GET_SERVICES } from './actions';

const initialState = {};

const servicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICES:
      return action.payload;

    default: {
      return state;
    }
  }
};

export default servicesReducer;
